export type CategoryIconId =
  | 'logic'
  | 'loop'
  | 'math'
  | 'variables'
  | 'arduino'
  | 'digital-io'
  | 'analog-io'
  | 'serial'
  | 'text'
  | 'lists'
  | 'functions'
  | 'led'
  | 'sensors'
  | 'actuators'
  | 'display'
  | 'lcd'
  | 'oled'
  | 'tft'
  | 'buzzer'
  | 'switch'
  | 'sound'
  | 'time'
  | 'rgb-led'
  | 'pixel-led'
  | 'active-buzzer'
  | 'passive-buzzer'
  | 'speaker'
  | 'microphone';

export interface CategoryCssConfig {
  icon?: string;
}

export function categoryCssConfig(iconId: CategoryIconId): CategoryCssConfig {
  return {
    icon: `skyrover-toolbox-icon skyrover-toolbox-icon--${iconId}`,
  };
}

export function categorySubCssConfig(iconId: CategoryIconId): CategoryCssConfig {
  return {
    icon: `skyrover-toolbox-icon skyrover-toolbox-icon--${iconId} skyrover-toolbox-subcategory-icon`,
  };
}
